import AddPositioningDeviceInfoModal from './add-positioning-device-info-modal.vue'
export default AddPositioningDeviceInfoModal
